import controller from './loading-spinner.controller.js';
import template from './loading-spinner.html';

let loadingSpinnerModule = angular.module('loading-spinner', [])

    .directive('loadingSpinner', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: { size: '@' },
            bindToController: true,
            template: template
        };
    })

    .name;

export default loadingSpinnerModule;



// WEBPACK FOOTER //
// ./src/app/angular/loading-spinner/loading-spinner.js